import React, { Component } from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

import BRFab from '../../common-components/BRFab';

import * as fastDataReducers from '../reducer/index';
import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as healthDataReducers from '../../health-data/reducer/index';
import * as stnFastDataReducer from '../../station-fastdata/reducer';
import * as systemReducer from '../../system/reducer';

import * as healthDataActionMgr from '../../health-data/action-mgr';
import * as stnFastDataActionMgr from '../../station-fastdata/action-mgr';
import * as actionManager from '../action-mgr';

import { topicPrefix, imgTopicPrefix } from '../constants';

import { reConnectMQTT } from '../../system/action-creator'
import * as mqttMgr from '../../helpers/MqttMgr';
import * as strings from '../../helpers/strings';
import { setFastDataStationId, getFastDataStationId } from '../../helpers/common';

const styles = {
  root: {
    width: "100%",
    height: '124px',
    textAlign: "center",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "7px",
    background: 'linear-gradient(0deg, #343A40, 3%, #F8F8F8 1%)',
    // background: 'linear-gradient(0deg, #3E54AC, 5%, #E3F6FF)'
  },
  '@global': {
    '.fastStationData .errorTypeDecs': {
      display: 'none !important'
    }
  },
  stationName: {
    fontSize: "1.5rem",
    margin: 0,
    fontWeight: 500,
  }
}

let noDatainterval;

class StationInfo extends Component {
  constructor() {
    super();

    this.handleStationChange = this.handleStationChange.bind(this);
    this.handleFastData = this.handleFastData.bind(this);
    this.checkNoData = this.checkNoData.bind(this);

    this.fn_mqttFocus = this.fn_mqttFocus.bind(this)
    this.fn_mqttBlur = this.fn_mqttBlur.bind(this)

    this.state = {
      loading: true
    }
  }

  handleFastData(fastData) {
    const { stationTimeOffset, addFastData } = this.props;
    const targetDate = new Date(fastData.timestamp);

    var timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60 // Current UTC date/time expressed as seconds since midnight, January 1, 1970 UTC
    var offsets = (stationTimeOffset) ? stationTimeOffset.dstOffset * 1000 + stationTimeOffset.rawOffset * 1000 : false // get DST and time zone offsets in milliseconds
    var localdate = new Date(timestamp * 1000 + offsets) // Date object containing current time of target location
    var refreshDate = new Date() // get current date again to calculate time elapsed between targetDate and now
    var millisecondselapsed = refreshDate - targetDate // get amount of time elapsed between targetDate and now
    localdate.setMilliseconds(localdate.getMilliseconds() + millisecondselapsed) // update localdate to account for any time elapsed

    fastData.timestamp = localdate.getTime();
    addFastData(fastData);
  }

  componentDidMount() {
    const { stations, selectedId, setSitePhotos, errorTypes, fetchErrorTypes, selectStationHealth, selectStation, getStationTimeOffset, getFindRealTimeFields, callStnTotalize, getuserMQTTData } = this.props;
    
    clearInterval(noDatainterval);

    setTimeout(() => {

      if (!errorTypes["1"])
        fetchErrorTypes();

      let stationId;
      if (getFastDataStationId()) {
        stationId = getFastDataStationId();

        if (!stations.filter(station => station.id === stationId).length)
          stationId = selectedId;

        selectStation(stationId);
      }

      else {
        stationId = selectedId;
      }

      const station = stations.filter(station => station.id === stationId)[0];

      if (station) {

        getFindRealTimeFields(station.name)
        const stationName = station.name;

        callStnTotalize(stationName);

        selectStationHealth(stationName);
        getStationTimeOffset(station)
          .then(() => {
            mqttMgr.addSubscriptionTopic(`${topicPrefix}${stationName}`, this.handleFastData);
            mqttMgr.sqsService(stationName)
          });
        mqttMgr.addSubscriptionTopic(`${imgTopicPrefix}${stationName}`, setSitePhotos);
      }

      reConnectMQTT(getuserMQTTData)

      //Browser Active
      window.addEventListener('focus', this.fn_mqttFocus);
      // Browser Inactive
      window.addEventListener('blur', this.fn_mqttBlur);

    }, 100)


    setTimeout(() => {

      noDatainterval = setInterval(() => {
        this.checkNoData()
      }, 60000);

    }, 2000)
  }

  componentWillUnmount() {
    // console.log("UNMOUNT!!!")
    const { stations, selectedId } = this.props;
    const station = stations.filter(station => station.id === selectedId)[0];
    if (station) {
      mqttMgr.removeSubscriptionTopic(`${topicPrefix}${station.name}`);
      mqttMgr.removeSubscriptionTopic(`${imgTopicPrefix}${station.name}`);
    }

    mqttMgr.disconnect()
    window.removeEventListener('focus', this.fn_mqttFocus)
    window.removeEventListener('blur', this.fn_mqttBlur)

    clearInterval(noDatainterval);
  }

  fn_mqttBlur() {

    const { stations, selectedId } = this.props;
    const station = stations.filter(station => station.id === selectedId)[0];
    if (station) {
      mqttMgr.removeSubscriptionTopic(`${topicPrefix}${station.name}`);
      mqttMgr.removeSubscriptionTopic(`${imgTopicPrefix}${station.name}`);
    }

    mqttMgr.disconnect()
  }

  fn_mqttFocus() {

    const { stations, selectedId, setSitePhotos, errorTypes, fetchErrorTypes, selectStationHealth, selectStation, getStationTimeOffset, getFindRealTimeFields, callStnTotalize, getuserMQTTData } = this.props;

    if (!errorTypes["1"])
      fetchErrorTypes();

    let stationId;
    if (getFastDataStationId()) {
      stationId = getFastDataStationId();

      if (!stations.filter(station => station.id === stationId).length)
        stationId = selectedId;

      selectStation(stationId);
    }
    else {
      stationId = selectedId;
    }

    const station = stations.filter(station => station.id === stationId)[0];

    if (station) {

      getFindRealTimeFields(station.name)
      const stationName = station.name;

      callStnTotalize(stationName);

      selectStationHealth(stationName);
      getStationTimeOffset(station)
        .then(() => {
          mqttMgr.addSubscriptionTopic(`${topicPrefix}${stationName}`, this.handleFastData);
          mqttMgr.sqsService(stationName)
        });
      mqttMgr.addSubscriptionTopic(`${imgTopicPrefix}${stationName}`, setSitePhotos);
    }

    reConnectMQTT(getuserMQTTData)
    this.setState({ browserStatus: false })
    setTimeout(() => {
      this.setState({ browserStatus: true })
    }, 1000);
  }

  handleStationChange = stationId => () => {
    const { stations, selectStation, selectedId, setSitePhotos, selectStationHealth, getStationTimeOffset, callStnTotalize, getFindRealTimeFields } = this.props;
    if (stationId !== selectedId) {
      setFastDataStationId(stationId);

      if (selectedId) {
        const stationName = stations.filter(station => station.id === selectedId)[0].name;
        mqttMgr.removeSubscriptionTopic(`${topicPrefix}${stationName}`);
        mqttMgr.removeSubscriptionTopic(`${imgTopicPrefix}${stationName}`);
      }

      const station = stations.filter(station => station.id === stationId)[0];
      const stationName = station.name;
      callStnTotalize(stationName);
      getFindRealTimeFields(stationName);
      getStationTimeOffset(station)
        .then(() => {
          mqttMgr.addSubscriptionTopic(`${topicPrefix}${stationName}`, this.handleFastData);
          mqttMgr.sqsService(stationName)
        })
      mqttMgr.addSubscriptionTopic(`${imgTopicPrefix}${stationName}`, setSitePhotos);
      selectStation(stationId);
      selectStationHealth(stationName);

    }
  }

  checkNoData() {
    const { getAllLastData } = this.props
    if (getAllLastData === null && document.getElementById("noData") && document.getElementById("connecting")) {
      document.getElementById("noData").innerHTML = "(No Data)"
      document.getElementById("connecting").innerHTML = ""
    } else {
      if (document.getElementById("noData")) {
        document.getElementById("noData").innerHTML = ""
      }
    }
  }

  render() {
    const { stations, selectedId, timestamp, selectedStationHealth, errorTypes, toggleStationListDialog, openedStationListDialog, getAllLastData, classes } = this.props;

    const filterStations = stations.filter(station => station.id === getFastDataStationId());

    let errorTypeDecs = "";
    if (filterStations.length > 0) {
      if (selectedStationHealth)
        errorTypeDecs = errorTypes[selectedStationHealth.errorType];
    }

    return (
<Paper className={classes.root}>
        {(stations.length > 0) ?
          [
            <Typography key="stationName" variant="h5" color={strings.colorPrimary} className={classes.stationName}>
              {(filterStations.length > 0) 
                ? `${filterStations[0].name} - ${filterStations[0].description}` 
                : `${stations[0].name} - ${stations[0].description}`
              }
            </Typography>,
            <Typography key="stationLocation" color={strings.colorPrimary}>
              {(filterStations.length > 0) ? filterStations[0].location : stations[0].location}
            </Typography>
          ]
          :
          <Typography key="noStation" variant="h5" color={strings.colorPrimary}>
            No Station
          </Typography>
        }
        <div>
          {(timestamp > 0) ? <Typography key="timestamp" variant="body1">{format(timestamp, strings.dateTimeFormat2)}</Typography> : <span id="connecting"> {"Connecting..."} </span>}
          {/* <span id="noData"> </span> */}
          <Typography key="errorType" variant="body1"><span className="errorTypeDecs">{errorTypeDecs}</span></Typography>
        </div>
        <BRFab onClick={toggleStationListDialog}><SettingsInputAntennaIcon /></BRFab>
        <Dialog onClose={toggleStationListDialog} aria-labelledby="simple-dialog-title" open={openedStationListDialog} >
          <DialogTitle id="simple-dialog-title">{strings.lblSelectStation}</DialogTitle>
          <div>
            <List>
              {stations.sort((a, b) => (a.name > b.name) ? 1 : -1).map(station => (
                <ListItem button onClick={this.handleStationChange(station.id)} key={station.id}>
                  <ListItemIcon>
                    {selectedId === station.id ? <SettingsInputAntennaIcon color={strings.colorPrimary} /> : <SettingsInputAntennaIcon />}
                  </ListItemIcon>
                  <ListItemText 
                      primary={`${station.name} - ${station.description}`}
                  />
                  <Radio checked={selectedId === station.id} color={strings.colorPrimary} />
                </ListItem>
              ))}
            </List>
          </div>
        </Dialog>
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),

  selectedId: fastDataReducers.getSelectedStationId(state),
  timestamp: fastDataReducers.getLastDateTime(state),
  openedStationListDialog: fastDataReducers.getOpenedStationListDialog(state),
  stationTimeOffset: fastDataReducers.getStationTimeOffset(state),
  getDashbaordWeatherInfo: stnFastDataReducer.getDashbaordWeatherInfo(state),
  selectedStationHealth: healthDataReducers.getSelectedStationHealth(state),
  errorTypes: healthDataReducers.getErrorTypes(state),

  getuserMQTTData: systemReducer.getuserMQTTData(state),

  getAllLastData: fastDataReducers.getAllLastData(state),
});

const mapActionsToProps = {
  addFastData: actionManager.addFastData,
  selectStation: actionManager.selectStation,
  toggleStationListDialog: actionManager.toggleStationListDialog,
  setSitePhotos: actionManager.setSitePhotos,
  getStationTimeOffset: actionManager.getStationTimeOffset,
  getFindRealTimeFields: stnFastDataActionMgr.getFindRealTimeFields,
  selectStationHealth: healthDataActionMgr.selectStation,
  fetchErrorTypes: healthDataActionMgr.fetchErrorTypes,
  callStnTotalize: actionManager.callStnTotalize,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(StationInfo)
);